var _document$HTMLInputEl;

import { isFunction } from './typeChecks';
var hasIsSameNode = isFunction((_document$HTMLInputEl = document.HTMLInputElement) === null || _document$HTMLInputEl === void 0 ? void 0 : _document$HTMLInputEl.prototype.isSameNode);

var isElementFocused = el => {
  if (!(el instanceof window.Element) || !document.activeElement) {
    return false;
  }

  var isFocused = hasIsSameNode ? document.activeElement.isSameNode(el) : document.activeElement === el;
  return isFocused;
};

var isFullyInViewport = el => {
  var _document$documentEle;

  var {
    bottom,
    top
  } = el.getBoundingClientRect();
  var winHeight = window.innerHeight || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientHeight);
  return bottom <= winHeight && top >= 0;
};

var scrollIntoViewIfNeeded = el => {
  var hasBoundingClientRect = isFunction(el.getBoundingClientRect);
  var hasScrollIntoView = isFunction(el.scrollIntoView);

  if (hasScrollIntoView && hasBoundingClientRect && !isFullyInViewport(el)) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};

export { isElementFocused, isFullyInViewport, scrollIntoViewIfNeeded };